import { render, staticRenderFns } from "./YearBarChart.vue?vue&type=template&id=3354b143&scoped=true"
import script from "./YearBarChart.vue?vue&type=script&lang=js"
export * from "./YearBarChart.vue?vue&type=script&lang=js"
import style0 from "./YearBarChart.vue?vue&type=style&index=0&id=3354b143&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3354b143",
  null
  
)

export default component.exports